import { Documentacion } from '../../../types/Reintegro/types';
import { ApiResponse, apiRequest } from '../../Utils/apiClient';
import {
  ADD_CBU_FILE,
  ADD_DNI_FILE,
  ADD_EXTRA_FILE,
  ADD_LIBRETA_VACUNACION_FILE,
  GET_DOCUMENTACION_EXISTENTE,
  GET_OTHER_FILES,
} from '../../Utils/constants';
import axios from '../../Utils/interceptors';

const getDocumentacion = async (
  siniestroId: string,
): Promise<ApiResponse<Documentacion>> =>
  apiRequest<Documentacion>('get', GET_DOCUMENTACION_EXISTENTE, { siniestroId });

const getOtherFiles = (siniestroId: string, label: string) =>
  apiRequest<any[]>('get', GET_OTHER_FILES, { siniestroId, label });

const postDocumentacion = async (url: string, formData: FormData, logMessage: string) => {
  try {
    await axios.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  } catch (error) {
    console.error(`Error al subir ${logMessage}:`, error);
  }
};

const addDni = (formData: FormData) => postDocumentacion(ADD_DNI_FILE, formData, 'DNI');

const addCbu = (formData: FormData) => postDocumentacion(ADD_CBU_FILE, formData, 'CBU');

const addLibretaVacunacion = (formData: FormData) =>
  postDocumentacion(ADD_LIBRETA_VACUNACION_FILE, formData, 'Libreta de vacunación');

const addExtra = (formData: FormData) =>
  postDocumentacion(ADD_EXTRA_FILE, formData, 'Documento extra');

export {
  getDocumentacion,
  getOtherFiles,
  addDni,
  addCbu,
  addLibretaVacunacion,
  addExtra,
};
